import React from 'react';
import { IonIcon } from '@ionic/react';
import { imageOutline, videocamOutline } from 'ionicons/icons';
import { Label } from '@/components/ui/label';
import { useTranslation } from 'react-i18next';

type MediaUploadButtonsProps = {
  mediaCount: number;
  onImageSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onVideoSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export function MediaUploadButtons({ mediaCount, onImageSelect, onVideoSelect }: MediaUploadButtonsProps) {
  const { t } = useTranslation('MGP');
  
  return (
    <div className="mb-4 flex gap-1">
      {mediaCount < 9 && (
        <Label
          htmlFor="image"
          className="flex w-fit cursor-pointer items-center justify-center gap-1 rounded-full text-primary bg-primary/20 px-4 py-2 shadow-sm transition-colors"
        >
          <IonIcon icon={imageOutline} className="size-5 mr-2" />
          <span className="grow text-center font-normal">{t('photos')}</span>
        </Label>
      )}
      <Label
        htmlFor="video"
        className="flex w-fit cursor-pointer items-center justify-center gap-1 rounded-full text-red-500 bg-red-700/20 px-4 py-2 shadow-sm transition-colors"
      >
        <IonIcon icon={videocamOutline} className="size-5 mr-2" />
        <span className="grow text-center font-normal">{t('video')}</span>
      </Label>
      
      <input
        id="image"
        type="file"
        accept="image/*"
        onChange={onImageSelect}
        multiple
        className="hidden"
      />
      <input
        id="video"
        type="file"
        accept="video/*"
        onChange={onVideoSelect}
        className="hidden"
      />
    </div>
  );
}
